import React from 'react';
import { AbsoluteFill, useCurrentFrame, interpolate, spring } from 'remotion';

// 目标追踪动画
export const GoalTrackingAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  
  const goals = [
    { text: '学习新技能', progress: 80 },
    { text: '健康生活', progress: 60 },
    { text: '阅读计划', progress: 40 },
  ];

  return (
    <AbsoluteFill style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: 80, color: 'white' }}>
      <h1 style={{ fontSize: 70, textAlign: 'center', marginBottom: 60 }}>
        目标追踪 🎯
      </h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 50 }}>
        {goals.map((goal, i) => {
          const width = interpolate(frame, [i * 30, i * 30 + 40], [0, goal.progress], { extrapolateRight: 'clamp' });

          return (
            <div key={i}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                <span style={{ fontSize: 36 }}>{goal.text}</span>
                <span style={{ fontSize: 36, fontWeight: 'bold' }}>{goal.progress}%</span>
              </div>
              <div style={{
                height: 30,
                background: 'rgba(255,255,255,0.2)',
                borderRadius: 15,
                overflow: 'hidden',
              }}>
                <div style={{
                  width: `${width}%`,
                  height: '100%',
                  background: 'linear-gradient(90deg, #f093fb 0%, #f5576c 100%)',
                  borderRadius: 15,
                  boxShadow: '0 4px 15px rgba(245, 87, 108, 0.4)',
                }} />
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};
